import { render, staticRenderFns } from "./Insumos.vue?vue&type=template&id=5ddefcc2&scoped=true"
import script from "./Insumos.vue?vue&type=script&lang=js"
export * from "./Insumos.vue?vue&type=script&lang=js"
import style0 from "./Insumos.vue?vue&type=style&index=0&id=5ddefcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddefcc2",
  null
  
)

export default component.exports